<template>
  <div v-if="!loading" class="layout" style="background-color: #f5f5f5">
    <van-tabs
      class="vantabs"
      :ellipsis="false"
      sticky
      v-model="active"
      animated
      swipeable
      color="#2E94E5"
      line-height="3px"
      title-active-color="#2E94E5"
    >
      <van-tab v-for="item in navData" :key="item.text" :title="item.text">
        <component
          v-if="item.show"
          :is="item.url"
          :list.sync="item.data"
          @show-dialog="showDialog"
        ></component>
      </van-tab>
    </van-tabs>
    <van-popup v-model="showSigns" closeable :style="{ height: '80%' }">
      <div class="sign-middle">
        <img src="http://img.xiaoqijiankang.com/images/signs.jpg" />
      </div>
    </van-popup>
    <BottomNav v-if="showNav == 1" />
  </div>
</template>
<script>
import Organ from "@/components/OrganGu"
import GuOrganDetail from "@/components/GuOrganDetail"
import Healthy from "@/components/Healthy"
import BottomNav from "@/components/BottomNav"
import Disease from "@/components/Disease"
import Report from "../../models/Report"
export default {
  components: { GuOrganDetail, Healthy, Organ, Disease, BottomNav },
  data () {
    return {
      showSigns: false,
      active: 0,
      loading: true,
      navData: [
        { text: '风险概览', url: 'Organ', list: 'organ', show: true, },
        { text: '器官详情', url: 'GuOrganDetail', list: 'physiology', show: true, },
        { text: '疾病风险', url: 'Disease', list: 'Disease', show: true, },
        { text: '健康管理建议', url: 'Healthy', list: 'healthy', show: true, },

      ],

    }
  },
  computed: {
    id () {
      return this.$route.query.id || ''
    },
    user_no () {
      return this.$route.query.user_no || ''
    },
    showNav () {
      return this.$route.query.showNav || 0
    },
  },
  methods: {
    showDialog () {
      this.showSigns = true;
    },
  },
  created () {
    let params = {
      user_no: this.user_no, // this.user_no
      test_report_id: this.id// this.id
    }
    Report.getReports({ ...params }, (res, err) => {
      this.loading = true
      if (!err) {
        res.info.healthy.forEach(e => {
          e.btntxt = "查看建议";
          e.showCon = false
        });
        res.info.special[0].descArr = res.info.special[0].desc.split('\\r\\n');

        for (let key in res.info.physiology_system) {
          res.info.physiology_system[key].forEach(e => {
            e.showDetail = false;
            e.remakrs = e.remakrs ? e.remakrs.split('\\r\\n') : []
          })
        }
        console.log(res.physiology_system)
        res.info.healthy.forEach((item) => {

          item.exam_references = item.exam_references ? item.exam_references.replace(/\\r\\n/g, '<br>') : []
        })
        this.navData[0].data = res;
        this.navData[1].data = {
          ...res.info.physiology,
          physiology_system: res.info.physiology_system
        };

        this.navData[2].data = res.info.bone_disease
        this.navData[3].data = {
          healthy: res.info.healthy,
          marks: res.marks
        }
        this.loading = false
      }
    })
  }
}
</script>
<style lang="scss" >
.layout {
  height: 100%;
}
.van-tabs--line .van-tabs__wrap {
  height: 80px !important;
  line-height: 80px;
  margin-bottom: 20px;
  width: 100%;
  font-size: 30px;
}
.van-tab__text {
  font-size: 30px;
}
.van-tabs__wrap--scrollable .van-tab {
  //    flex: 0 0 27% !important;
  font-size: 30px;
}
.vantabs {
  font-size: 30px;
  //    height: calc(100% - 100px);
  padding-bottom: 100px;
}
.van-tab__text--ellipsis {
  overflow: visible !important;
}
</style>